// trims JS Object or Array prototypes
const trim = o => {
  return JSON.parse(JSON.stringify(o))
}
export default trim



// WEBPACK FOOTER //
// ./src/tools/trim.js